import * as React from 'react';
import {
  IApp,
  ITile,
  NotificationsBL,
  Project,
} from 'matrix-requirements-sdk/client';
import {
  AnalyticsTile,
  BigNumber,
  Card,
  Pie,
  PieProps,
  StylesProvider,
} from '@matrixreq/ui';
import { createRoot, Root } from 'react-dom/client';
import { sdkInstance } from './Instance';
import { Plugin } from './Plugin';
import { DashboardPage } from './DashboardPage';
import { createRef } from 'react';
const ml = sdkInstance.ml;
const app = sdkInstance.app as IApp;
const matrixsdk = sdkInstance.matrixsdk;
const globalMatrix = sdkInstance.globalMatrix;
const matrixSession = sdkInstance.matrixSession;
const UIToolsConstants = sdkInstance.UIToolsConstants;

interface IProps {
  Project: Project;
}

interface IState {
  data?: PieProps[];
  isLoading?: boolean;
  loaded?: string;
  label?: string;
}
export class Tile implements ITile {
  root: Root = undefined;
  private ref: React.RefObject<TileComponent>;

  canBeRendered() {
    return true;
  }
  getTitle() {
    return 'Traceability overview';
  }
  getOrder() {
    return 1000;
  }
  async render(containerElement: HTMLElement) {
    if (this.root !== undefined) {
      this.root.unmount();
    }
    this.ref = createRef<TileComponent>();

    let project = await sdkInstance.matrixsdk.openCurrentProjectFromSession();
    // let's add a root div to the container

    this.root = createRoot(containerElement);
    this.root.render(
      <StylesProvider>
        <TileComponent ref={this.ref} Project={project}></TileComponent>
      </StylesProvider>,
    );
  }
  refresh() {
    return this.ref.current.refresh();
  }
  async canBeRenderedAsync() {
    return true;
  }
}

class TileComponent extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = { isLoading: true };
    // Get the notifications from the cache
    setTimeout(() => this.refresh(), 1);
  }
  load() {}
  componentDidMount() {}

  componentWillUnmount() {}

  async refresh() {
    let d = new DashboardPage(
      this.props.Project,
      sdkInstance.globalMatrix.projectStorage,
    );
    d.init();
    let lastSelection = d.getLastSelection();
    let items = await d.getItems(lastSelection);
    let inputData = d.calculateTraceData(items, DashboardPage.getRules());
    let pieData: PieProps[] = [];

    pieData.push({
      value:
        inputData.allItems.length -
        inputData.itemWithUpTraceMissing.length -
        inputData.itemsWithAllCoverageMissing.length -
        inputData.itemsWithDownTraceMissing.length,
      id: 'All covered',
      color: UIToolsConstants.CIColors.GreenSushi.color,
      label: 'All covered',
    });

    if (inputData.hasUpMust) {
      pieData.push({
        value: inputData.itemWithUpTraceMissing.length,
        id: 'Missing up link',
        color: UIToolsConstants.CIColors.YellowBrightSun.color,
        label: 'Up trace missing',
      });
    }
    if (inputData.hasDownMust) {
      pieData.push({
        value: inputData.itemsWithDownTraceMissing.length,
        id: 'Missing down link',
        color: UIToolsConstants.CIColors.OrangeYellow.color,
        label: 'Down trace missing',
      });
    }
    pieData.push({
      value: inputData.itemsWithAllCoverageMissing.length,
      id: 'Missing up and down links',
      color: UIToolsConstants.CIColors.RedPersimmon.color,
      label: 'Missing up and down links',
    });

    this.setState((state, prop) => ({
      data: pieData,
      label: 'Labels',
      isLoading: false,
      loaded: new Date().toISOString(),
    }));
  }
  render() {
    return (
      <AnalyticsTile
        id={'com.matrixreq.core.trace'}
        name={'Traceability overview'}
        lastUpdated={this.state.loaded ?? ' ?'}
        isLoading={this.state.isLoading}
        onRefreshAction={() => {
          this.refresh();
        }}
        onViewAction={() => {
          window.open(
            `${globalMatrix.matrixBaseUrl}/${matrixSession.getProject()}/${Plugin.config.dashboard.id}`,
            '_self',
          );
        }}
      >
        <Pie data={this.state.data}></Pie>
      </AnalyticsTile>
    );
  }
}
